import { gsap } from 'gsap'
import Cookies from 'js-cookie'

Drupal.behaviors.AutryBlockNotification = {
  // used to set the cookie value, and also to read
  // the current value from the markup to compare
  cookieValue: block => {
    // Cookie is valid for "once a day". Rather than
    // a 24-hour expiration, actually check the mm/dd
    // value in the cookie against today
    const mm = new Date().getMonth()
    const dd = new Date().getDate() + 1
    // ...but also check the datestamp of the notification.
    // if it's been changed, show it.
    const uuid = block.getAttribute('data-uuid')
    return `${mm}.${dd}:${uuid}`
  },
  dismiss: e => {
    if (e.target.tagName.toUpperCase() === 'BUTTON') {
      const block = document.getElementById('autry-notification')
      gsap.set(block, {
        height: block.offsetHeight
      })
      gsap
        .to(block, {
          duration: 0.35,
          opacity: 0,
          height: 0,
          ease: 'power2.out'
        })
        .then(() => {
          block.setAttribute('aria-hidden', 'true')
          const value =
            Drupal.behaviors.AutryBlockNotification.cookieValue(block)
          Cookies.set('autry-notification', value, {
            path: '',
            expires: 1
          })
        })
    }
  },
  attach: (context, settings) => {
    const elements = once('AutryBlockNotification', '#autry-notification')
    elements.forEach(block => {
      const value = Drupal.behaviors.AutryBlockNotification.cookieValue(block)
      // if not yet seen today (or changed), make visible
      if (Cookies.get('autry-notification') !== value) {
        document
          .getElementById('autry-notification')
          .removeAttribute('aria-hidden')
      }

      block.addEventListener(
        'click',
        Drupal.behaviors.AutryBlockNotification.dismiss,
        {
          once: true
        }
      )
    })
  }
}
